export const layoutMeasures = {
  statePanel: { cardMaxWidth: '560px' },
  popover: { width: 'max-content' },
  viewport: {
    fullHeight: '100vh',
    contentMinHeight: '60vh',
    authMinHeight: '75dvh',
    blockedMinHeight: '70vh',
  },
} as const;
